import React from "react";
import {
  PeopleAltOutlined,
  Payment,
  Apartment,
  AccountBalanceWalletTwoTone,
  FindReplace,
  FindReplaceRounded,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import "./style.css";

const CampusDashboard = ({ studentCount = 0 }) => {
  const history = useHistory();

  const actions = [
    {
      Icon: Payment,
      label: "Print Fee Bill",
      hint: "Generate student challans",
      path: "/student-wise-print",
      tone: "blue",
    },
    {
      Icon: PeopleAltOutlined,
      label: "Mark Attendance",
      hint: "Record today's attendance",
      path: "/markattendance",
      tone: "green",
    },
    {
      Icon: Apartment,
      label: "Edit Student",
      hint: "Update enrolled records",
      path: "/showallstudents",
      tone: "amber",
    },
    {
      Icon: AccountBalanceWalletTwoTone,
      label: "Students Due Fee",
      hint: "Review outstanding balances",
      path: "/due-fee",
      tone: "red",
    },
    {
      Icon: FindReplace,
      label: "Find Student",
      hint: "Search admissions quickly",
      path: "/findstudent",
      tone: "violet",
    },
    {
      Icon: FindReplaceRounded,
      label: "Find Staff",
      hint: "Locate employee profiles",
      path: "/searchstaff",
      tone: "cyan",
    },
  ];

  const overview = [
    { label: "Students", value: studentCount, meter: Math.min(studentCount, 100), tone: "blue" },
    { label: "Daily Tasks", value: actions.length, meter: 72, tone: "green" },
    { label: "Fee Desk", value: "Active", meter: 88, tone: "amber" },
  ];

  return (
    <div className="campus-dashboard modern-dashboard">
      <div className="dashboard-section-head">
        <div>
          <span>Campus Operations</span>
          <h4>Today at a glance</h4>
        </div>
      </div>

      <div className="modern-kpi-grid">
        {overview.map(({ label, value, meter, tone }) => (
          <div className={`modern-kpi-card ${tone}`} key={label}>
            <span>{label}</span>
            <strong>{value || 0}</strong>
            <div className="modern-meter">
              <i style={{ width: `${meter}%` }} />
            </div>
          </div>
        ))}
      </div>

      <div className="modern-action-grid">
        {actions.map(({ Icon, label, hint, path, tone }) => (
          <button
            type="button"
            key={label}
            onClick={() => history.push(path)}
            className={`modern-action-card ${tone}`}
          >
            <span className="modern-action-icon">
              <Icon />
            </span>
            <span className="modern-action-copy">
              <strong>{label}</strong>
              <small>{hint}</small>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CampusDashboard;
